"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var l10n_1 = __importDefault(require("@paprika/l10n"));
var helpers_1 = require("@paprika/helpers");
var locales_1 = __importDefault(require("../locales"));
var Title_1 = __importDefault(require("./components/Title"));
var Icon_1 = __importDefault(require("./components/Icon"));
var Breadcrumbs_1 = __importDefault(require("./components/Breadcrumbs"));
var Side_1 = __importDefault(require("./components/Side"));
var context_1 = __importDefault(require("./context"));
var sc = __importStar(require("./PageHeader.styles"));
var PageHeaderWithL10n = function (props) {
    var i18n = useI18n_1.default();
    var locale = props.locale, otherProps = __rest(props, ["locale"]);
    return (react_1.default.createElement(l10n_1.default, { locale: props.locale || (i18n === null || i18n === void 0 ? void 0 : i18n.locale), locales: locales_1.default },
        react_1.default.createElement(PageHeader, __assign({}, otherProps))));
};
function PageHeader(_a) {
    var children = _a.children, _b = _a.isDark, isDark = _b === void 0 ? false : _b, _c = _a.hasTabsBelow, hasTabsBelow = _c === void 0 ? false : _c, _d = _a.zIndex, zIndex = _d === void 0 ? 1 : _d, moreProps = __rest(_a, ["children", "isDark", "hasTabsBelow", "zIndex"]);
    var _e = helpers_1.extractChildren(children, [Breadcrumbs_1.default.displayName, Title_1.default.displayName, Icon_1.default.displayName, Side_1.default.displayName]), _f = Breadcrumbs_1.default.displayName, extractedBreadcrumbs = _e[_f], _g = Title_1.default.displayName, extractedTitle = _e[_g], _h = Icon_1.default.displayName, extractedIcon = _e[_h], _j = Side_1.default.displayName, extractedSide = _e[_j];
    var configurationContextValue = react_1.default.useMemo(function () { return ({
        isDark: isDark,
        zIndex: zIndex,
    }); }, [isDark, zIndex]);
    return (react_1.default.createElement(context_1.default.Provider, { value: configurationContextValue },
        react_1.default.createElement(sc.PageHeader, __assign({ "data-sri-anchor": "page-header", hasTabsBelow: hasTabsBelow, isDark: isDark }, moreProps),
            extractedIcon && react_1.default.createElement("div", { "data-sri-anchor": "page-header.icon" }, extractedIcon),
            react_1.default.createElement(sc.ContentGroup, { "data-sri-anchor": "page-header.content-group" },
                extractedBreadcrumbs,
                extractedTitle),
            extractedSide)));
}
PageHeaderWithL10n.displayName = 'PageHeader';
PageHeaderWithL10n.Title = Title_1.default;
PageHeaderWithL10n.Icon = Icon_1.default;
PageHeaderWithL10n.Breadcrumbs = Breadcrumbs_1.default;
PageHeaderWithL10n.Side = Side_1.default;
exports.default = PageHeaderWithL10n;
//# sourceMappingURL=PageHeader.js.map